import { ILoginFormLang, LOGIN_FORM_LANG_KEY } from './interface.ILoginFormLang'

export * from './interface.ILoginFormLang'

export type ILoginAllLang =
	& ILoginFormLang

export const LOGIN_ALL_LANG_KEY: ILoginAllLang = {
	...LOGIN_FORM_LANG_KEY,
}
